import { render, staticRenderFns } from "./ChoosePolType.vue?vue&type=template&id=02bf8c8d&scoped=true"
import script from "./ChoosePolType.vue?vue&type=script&lang=js"
export * from "./ChoosePolType.vue?vue&type=script&lang=js"
import style0 from "./ChoosePolType.vue?vue&type=style&index=0&id=02bf8c8d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bf8c8d",
  null
  
)

export default component.exports